const gameCommunication = require('@nolimitcity/game-communication');
const replay = require('./replay');
const lastBet = require('./last-bet');
const error = require('./error');

const communication = {
    replayMode: false,
    init(api) {
        this.api = api;

        const promise = api.startupPromise('communication.init');
        api.events.once('init', onInit);

        function onInit() {
            promise.fulfill();
        }

        gameCommunication.any((name, data) => {
            if(name === 'error' || data.error) {
                const errorMessage = {
                    code: data.code || error.CODES.COMMUNICATION,
                    message: data.error || data.message || data,
                    reinitGame: data.reinitGame || false,
                    dialog: data.dialog || {}
                };
                api.events.trigger('error', errorMessage);
                promise.break(errorMessage.message);
            } else if(name === 'debug') {
                for(let key in data) {
                    api.log(key, data);
                }
            } else if(name === 'id') {
                api.log('Communication id:', data);
            } else {
                api.events.trigger(name, data);
            }
        });

        if(api.options.replay) {
            this.replayMode = true;
            replay.init(api, api.options.replay);
        } else {
            gameCommunication.on('connected', parameters => {
                communication.url = parameters.url;
                communication.key = parameters.key;
            });

            const communicationOptions = Object.assign({}, api.options);
            communicationOptions.lastBet = lastBet.load();
            gameCommunication.connect(communicationOptions);

            let balanceTimeout;
            api.events.on('hidden', hidden => {
                if(!hidden) {
                    clearTimeout(balanceTimeout);
                    balanceTimeout = setTimeout(() => {
                        communication.refreshBalance();
                    }, 1000);
                }
            });
        }
    },

    refreshBalance() {
        if(!this.replayMode) {
            let data;
            const balanceId = this.api.settings.get('balanceId', undefined);
            if (balanceId) {
                data = {
                    balanceId : balanceId
                };
            }
            gameCommunication.balance(lastBet.load(), data);
        }
    },

    send(type, content) {
        if(!this.replayMode) {
            gameCommunication.send(type, content);
        } else if(type === 'normal') {
            this.api.events.trigger('replayBet', content);
        }
    },

    getParameters() {
        return {url: this.url, key: this.key};
    },

    history: gameCommunication.history,
    outcome: gameCommunication.outcome
};

module.exports = communication;
